import tw, { css, styled } from 'twin.macro'
import { Link } from 'gatsby'

export const HeroSection = tw.section`flex flex-col bg-dark-grayish-blue w-full py-16 items-center`
export const Category = tw.p`text-white font-display tracking-widest uppercase text-sm`
export const DateAndTime = styled(Category)``
export const Title = tw.h1`font-display text-2xl text-white font-bold my-2 px-6 text-center`

export const MainSection = styled.section`
	${tw`py-12 md:py-20 w-full`}
	background-color: #eeeeee;
`
export const StorySidebarContainer = tw.div`flex flex-col md:flex-row md:px-4 lg:w-11/12 xl:w-4/5 xxl:w-8/12 m-auto`
export const StoryContainer = tw.div`flex flex-col w-full px-4 md:w-2/3 xl:w-3/4 md:pr-4 lg:pr-12`
export const Main = tw.div`w-full mb-16 md:mb-0`
export const MainTextContainer = tw.div`flex flex-col`
export const MainImageContainer = styled.div`
	${tw`overflow-hidden`}
	img {
		${tw`m-auto`}
	}
`
export const Texts = tw.p`font-display my-4 leading-relaxed`
export const BlockQuote = tw.blockquote`font-display bg-white pl-16 pr-4 sm:pl-32 sm:pr-16 py-8 my-4`
export const Quote = styled.q`
	${tw`relative text-2xl`}
	&::before {
		content: '❞';
		${tw`text-dark-grayish-blue absolute`}
		font-family: 'icons';
		font-size: 40px;
		left: -50px;
		top: -5px;
	}
`
export const QuoteAuthor = tw.p`mt-4 text-dark-grayish-blue`
export const SubHead = tw.h3`font-display mt-4 font-bold text-2xl`
export const EmbeddedAssetContainer = styled(MainImageContainer)`
	${tw`my-2`}
`
export const ImageWrapContainer = styled.span`
	&::before {
		content: '';
		display: block;
		float: right;
		height: 80px;
	}
	img {
		${tw`float-left w-6/12 pr-4`}
		clear: both;
	}
	& ~ span {
		${tw`block`}
		min-height: 10px;
	}
`
export const TagContainer = tw.div`flex flex-row mt-8 flex-wrap`
export const TagItem = tw.p`font-display mr-2 p-1 bg-white text-sm mb-2`
export const NextPrevContainer = tw.div`flex flex-col sm:flex-row py-16`
export const PrevContainer = styled.div`
	${tw`flex flex-col mr-6 text-right w-full sm:w-6/12 mb-4 sm:mb-0 text-dark-grayish-blue`}
	> a {
		${tw`bg-white hover:bg-gray-500 px-6 pb-6 pt-12 h-full`}
	}
`
export const NextContainer = styled.div`
	${tw`flex flex-col w-full sm:w-6/12 text-dark-grayish-blue`}
	> a {
		${tw`bg-white hover:bg-gray-500 px-6 pb-6 pt-12 h-full`}
	}
`
export const NextPrevTitle = tw.div`font-bold text-dolphin-gray mt-2`
export const RelatedPostContainer = tw.div`flex flex-col pt-12 pb-12 md:pb-0 border-solid border-t-2 border-b-2 md:border-b-0 border-dark-grayish-blue w-full`
export const RelatedPostHead = tw.h3`font-display text-xl mb-4 text-center font-bold`
export const PostsContainer = styled.div`
	${tw`flex flex-col sm:flex-row justify-center`}
	> div:not(:last-of-type) {
		${tw`mr-0 sm:mr-4 mb-4 sm:mb-0`}
	}
`
export const RelatedPost = styled.div`
    background: url('${({ bg }) => (bg ? bg : '')}');
    ${tw`flex flex-col sm:py-0 sm:w-1/3 justify-center bg-no-repeat bg-cover bg-center`}
    	> a {
		${tw`p-8 flex flex-col h-full justify-center`}
        background-color: rgba(0,0,0, .3);
        min-height: 180px;
	}
`
export const RelatedPostTitle = tw.p`font-display text-white font-bold text-center mb-2`
export const RelatedDate = tw.p`font-display text-white text-center text-sm`

export const OtherPostsSection = tw.section`flex flex-col w-full lg:w-11/12 xl:w-4/5 xxl:w-8/12 m-auto px-8 py-12`
export const OtherPostsHead = tw.h3`font-display text-xl mt-4 mb-8`

export const OtherPostsContainer = styled.div`
	${tw`flex flex-row flex-wrap justify-center`}

	> a {
		${tw`pb-4`}
	}
	> a:not(:nth-of-type(2n)) {
		${tw`sm:pr-4 md:pr-0`}
	}
	> a:not(:nth-of-type(4n)) {
		${tw`md:pr-4`}
	}

	> a {
		${tw`flex flex-col w-full sm:w-1/2 md:w-3/12`}
	}
`
export const SingePostContainer = tw.div`bg-light-grayish-navy h-full`
export const ImageContainer = styled.div`
	background: url('${({ bg }) => (bg ? bg : '')}');
	${tw`overflow-hidden bg-no-repeat bg-cover bg-center w-full`}
	height: 160px;
	max-height: 300px;
`
export const SvgContainer = styled.div`
	${tw`p-8 bg-white border border-solid`}
	height: 160px;
`
export const PostDetailsContainer = tw.div`px-4 pt-4`
export const PostCat = tw.p`font-display uppercase text-white mb-2 tracking-wider text-center text-sm`
export const PostTtl = tw.h3`font-display text-white text-xl font-bold mb-4 text-center`
export const PostDateTime = tw.p`font-display text-sm text-white tracking-widest mb-6 text-center`
export const MainHead1 = tw.h1`font-display mt-4 font-bold text-4xl`
export const MainHead2 = tw.h2`font-display mt-4 font-bold text-3xl`
export const MainHead4 = tw.h4`font-display mt-4 font-bold text-xl`
export const MainHead5 = tw.h5`font-display mt-4 font-bold text-lg`
export const MainHead6 = tw.h6`font-display mt-4 font-bold text-base`
export const ListItem = tw.li`list-disc font-display`
export const UnorderedList = tw.ul`ml-6`
export const ContentLink = styled.a`
	${tw`underline text-blue-500 hover:no-underline font-display`}
`
export const CreatedElement = styled.div`
	> iframe {
		${tw`w-10/12 mx-auto mb-6`}
		min-height: 380px
	}
`
